import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

class DateTZ extends Date{
  constructor(date = dayjs().tz('UTC', true).toDate(), parse = false) {
    if (date instanceof dayjs) {
      date = date.toDate();
    }
    super(date);
    this.parse = parse;
    this._date = date;
    this.dayjs = date === null || date === undefined || isNaN(this) ? null : (this.parse && typeof this._date === 'string' ? dayjs(this._date, this.parse).tz('UTC', false) : dayjs.tz(this, 'UTC'));
  }

  getDateTimeString(format = 'DD.MM.YYYY HH:mm:ss') {
    return this.dayjs ? this.dayjs.format(format) : '';
  }

  getISOString(format = 'YYYY-MM-DDTHH:mm:ss.SSS') {
    return this.dayjs ? this.dayjs.format(format) : '';
  }

  getDate() {
    return this.dayjs ? this.dayjs.toDate() : null;
  }

  getDayjs() {
    return this.dayjs;
  }

  getTimeString() {
    return this.dayjs ? this.dayjs.format('HH:mm') : '';
  }

  getDayString(format = 'DD.MM.YYYY') {
    return this.dayjs ? this.dayjs.format(format) : '';
  }

  format(format) {
    return this.dayjs ? this.dayjs.format(format) : '';
  }

  reset() {
    this.dayjs = isNaN(this) ? null : (this.parse ? dayjs(this._date, this.parse).tz('UTC', false) : dayjs.tz(this, 'UTC'));
    return this;
  }

  isValid() {
    return this.dayjs === null || dayjs.isValid();
  }

  isSameDate(date) {
    const sameDate = new DateTZ(date);
    return this.dayjs && sameDate.dayjs ? sameDate.dayjs.startOf('day').isSame(this.dayjs.startOf('day')) : false;
  }

  isAfter(date) {
    const afterDate = new DateTZ(date);
    return this.dayjs && afterDate.dayjs ? this.dayjs.isAfter(afterDate.dayjs) : false;
  }

  isBefore(date) {
    const beforeDate = new DateTZ(date);
    return this.dayjs && beforeDate.dayjs ? this.dayjs.isBefore(beforeDate.dayjs) : false;
  }

  add(count = 0, modifier = 'days') {
    if (this.dayjs) {
      this.dayjs.add(count, modifier);
      this.setTime(this.dayjs.toDate().getTime());
    }
  }

  subtract(count = 0, modifier = 'days') {
    if (this.dayjs) {
      this.dayjs.subtract(count, modifier);
      this.setTime(this.dayjs.toDate().getTime());
    }
  }
}

export const TIMEZONE = dayjs.tz.guess();

DateTZ.startOf = (unit = 'day') => new DateTZ(dayjs().tz('UTC', false).startOf(unit));
DateTZ.endOf = (unit = 'day') => new DateTZ(dayjs().tz('UTC', false).endOf(unit));
DateTZ.add = (...args) => new DateTZ(dayjs().tz('UTC', false).add(...args));
DateTZ.subtract = (...args) => new DateTZ(dayjs().tz('UTC', false).subtract(...args));

export default DateTZ;